import type { IframeMessage } from './types'
import { ButtonMessageType, ChatMessageType, GreetingMessageType } from './enums'

export function isWindow(source: unknown): source is typeof window {
  return source !== null && source !== undefined && typeof source === 'object' && 'postMessage' in source
}

export function isButtonMessageType(type: string): type is ButtonMessageType {
  return Object.values(ButtonMessageType).includes(type as ButtonMessageType)
}

export function isChatMessageType(type: string): type is ChatMessageType {
  return Object.values(ChatMessageType).includes(type as ChatMessageType)
}

export function isGreetingMessageType(type: string): type is GreetingMessageType {
  return Object.values(GreetingMessageType).includes(type as GreetingMessageType)
}

export function isValidSettings(payload: unknown): payload is { settings: Record<string, unknown> } {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    'settings' in payload &&
    typeof (payload as { settings: unknown }).settings === 'object' &&
    (payload as { settings: unknown }).settings !== null &&
    !Array.isArray((payload as { settings: unknown }).settings)
  )
}

export function isValidMessageData(data: unknown): data is IframeMessage {
  return (
    typeof data === 'object' &&
    data !== null &&
    'type' in data &&
    typeof (data as { type: unknown }).type === 'string'
  )
}
